var _path, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _rect4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 123,
    viewBox: "0 0 124 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 40.5C38.6502 47.49 39.9187 51.1236 43.5 57M46 61C47.1651 62.5564 47.6926 63.1726 48.5 64",
    stroke: "#6ECDA9",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_508_406",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 107,
    width: 56,
    height: 16,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 107,
    width: 56,
    height: 16,
    rx: 2,
    stroke: "#6ECDA9",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1_508_406)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_508_406",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 100,
    width: 36,
    height: 11,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 100,
    width: 36,
    height: 11,
    rx: 2,
    stroke: "#6ECDA9",
    strokeWidth: 6,
    mask: "url(#path-3-inside-2_508_406)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-3_508_406",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 89,
    width: 16,
    height: 13,
    rx: 2
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 89,
    width: 16,
    height: 13,
    rx: 2,
    stroke: "#6ECDA9",
    strokeWidth: 6,
    mask: "url(#path-4-inside-3_508_406)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 82,
    width: 22,
    height: 8,
    rx: 4,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 94,
    x2: 24,
    y2: 100,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: 76,
    x2: 102,
    y2: 82,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: 93,
    x2: 91,
    y2: 94,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: 82,
    x2: 36,
    y2: 83,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: 71,
    x2: 14,
    y2: 72,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 97,
    x2: 27,
    y2: 97,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: 79,
    x2: 105,
    y2: 79,
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 2C29.5 32 28.0881 50.5366 44.5 69C48.5 73.5 50 72.5 53.5 76.5C57 80.5 57 81.5 57 81.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 2C94.5 32 95.9119 50.5366 79.5 69C75.5 73.5 74 72.5 70.5 76.5C67 80.5 67 82 67 82",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19.5C20.9348 17.4724 14.5 17 11.5 20.5C5.63382 27.3438 19.5 63 37.5 60.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97 19.5C103.065 17.4724 109.5 17 112.5 20.5C118.366 27.3438 104.5 63 86.5 60.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11.5C19.0207 8.69863 9.69877 9.38136 5.5 14C-4.5 25 9.5 72.5 43 69",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97 11.5C104.979 8.69863 114.301 9.38136 118.5 14C128.5 25 114.5 72.5 81 69",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 2H97",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29 9L96 9.00001",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.b3cdd793e3cb392fc75bb70ac08bc6f1.svg";
export { ForwardRef as ReactComponent };